import { render, staticRenderFns } from "./PacienteForm.vue?vue&type=template&id=27f8b1bb&"
import script from "./PacienteForm.vue?vue&type=script&lang=js&"
export * from "./PacienteForm.vue?vue&type=script&lang=js&"
import style0 from "./PacienteForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports